import * as E from 'fp-ts/lib/Either';

import {push} from 'connected-react-router';
import {all, call, put, takeEvery} from 'redux-saga/effects';

import {AsyncResult} from 'Core/models/Async';

import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as V from 'ApplicationEntry/ducks/verifyCriticalInformation';
import {getCaseName, getSalaryDeductionBillingInfo} from 'ApplicationEntry/api/awdApi';
import {BillingMode} from './billingAgentSaga';

function* getCaseNameSaga() {
  yield takeEvery(V.VerifyCriticalInformationActionType.GET_CASE_NAME, function*(
    action: ReturnType<typeof V.getCaseNameByCaseNumber>
  ) {
    const response: AsyncResult<{
      saldBillingInfoDto: {billingMode: BillingMode; salaryDeductionBillingCode: string; caseName: string};
    }> = yield call(getSalaryDeductionBillingInfo, action.payload.caseNumber);

    if (E.isRight(response)) {
      yield put(V.changeCaseName(response.right?.saldBillingInfoDto?.caseName));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(V.changeCaseNumberError(action.payload.caseNumber));
    }
  });
}

export default function*() {
  yield all([getCaseNameSaga()]);
}
